var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconInstagram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25,
  viewBox: "0 0 25 25"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  stroke: "#41CD8C",
  strokeWidth: 2,
  rx: 6
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 11.5,
  r: 5.5,
  stroke: "#41CD8C",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18.5,
  cy: 4.5,
  r: 1.5,
  fill: "#41CD8C"
}))));
export default SvgIconInstagram;